import { useState } from 'react'
import clsx from 'clsx'

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleIcon,
  CollapsibleTrigger,
} from '@wartek-id/collapsible'
import { Shimmer } from '@wartek-id/shimmer'
import { Icon } from '@wartek-id/icon'

import type { FC, ReactElement } from 'react'

interface AccordionProps {
  title: string
  children: ReactElement | string
  initialOpen?: boolean
  isLoading?: boolean
  isError?: boolean
}

const Accordion: FC<AccordionProps> = ({
  title,
  children,
  initialOpen = true,
  isLoading = false,
  isError = false,
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen)

  return (
    <Collapsible
      open={isOpen}
      onToggle={(v) => {
        if (!isLoading) setIsOpen(v)
      }}
      defaultOpen
      className={clsx({
        'border rounded': true,
        'border-[#E02D38]': isError,
        'border-subdued': !isError,
      })}
    >
      <CollapsibleTrigger
        as="div"
        className={clsx({
          '!bg-white !p-4 !border-t-0': true,
          '!border-b-[#E02D38]': isOpen && isError,
          '!border-subdued': isOpen,
          'rounded-t': isOpen,
          rounded: !isOpen,
        })}
      >
        {isLoading ? (
          <Shimmer width="100%" />
        ) : (
          <>
            <div className="flex items-center">
              {title}
              {isError && (
                <Icon color="critical" className="ml-2">
                  close
                </Icon>
              )}
            </div>
            <CollapsibleIcon />
          </>
        )}
      </CollapsibleTrigger>
      <CollapsibleContent className="bg-white rounded-b p-4">
        {children}
      </CollapsibleContent>
    </Collapsible>
  )
}
export default Accordion
